import React, { useEffect, useContext, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppContext, DispatchContext } from "../AppContext";
import Service from "../services/service";
import * as actions from "../actions/actions";
import { config, resolveNotificationMessage } from '../helpers/constants';
import { Typography, FormControl, InputLabel, Select, MenuItem, Grid } from "@material-ui/core";
import PriceCard from './PriceCard';


const useStyles = makeStyles((theme) => ({
  paper: {
    width: 850,
    minHeight: 600,
    position: "relative",
    boxShadow: "0px 0px 5px 5px rgba(0, 0, 0, 0.25)",
    "&:hover": {
      boxShadow: "0px 0px 7px 7px rgba(0, 0, 0, 0.4)",
      transition: "box-shadow 0.3s ease-in-out",
    }
  }
}));

export default function WizardSelectProductPanel(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  const wz = state.checkout.wizard;
  const classes = useStyles();

  useEffect(() => {
    if (!state.checkout.productId && wz.requiredProductId) {
      handleProductChange(wz.requiredProductId)
    }
  }, []);

  const handleProductChange = (newProductId) => {
    // if a product is de-selected, select the "free" product even if it is not displayed
    newProductId = (state.checkout.productId != newProductId) ? newProductId : 30110;
    dispatch(actions.setCheckoutDetails({ productId: newProductId, invoiceId: null }));
  }

  const handleCheckoutChange = (newValue, key) => {
    dispatch(actions.setCheckoutDetails({ [key]: newValue }));
  }

  const remainingCredits = wz.availableCreditsAfterCheckout - wz.requiredCredits;
  
  return (
    <div style={{ marginTop:16, display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Grid container justify="center" spacing={1}>
        {state.checkout.products.filter(p => p.categoryId == 1).map((price) => (
          <Grid item key={price.id}>
            { ((price.id !== 30110) || (state.user.guest)) && ((price.id !== 30114) || (!state.user.guest)) &&
              <PriceCard title={price.nameShort} text1={s.paymentDialog.priceCardCredits.format(price.credits)} text2={s.paymentDialog.priceCardPages.format(price.credits)}
                text3={price.users}
                price={price.cost[state.checkout.currency]}
                currency={state.checkout.currency}
                selected={state.checkout.productId === price.id}
                productId={price.id}
                handleChange={handleProductChange}
                taxIncluded={state.checkout.taxIncluded}
                vatRate={state.checkout.vatRate}
                disabled={true}
              />}
          </Grid>
        ))}
      </Grid>

      <div style={{ display: "flex", width: 680, marginTop: 32, justifyContent: "space-between" }}>
        <div style={{ width: 540 }}>
          <Typography color="primary">{s.wizard.requiredAvailableCredits.format(wz.requiredCredits, wz.availableCreditsAfterCheckout)}</Typography>
          {remainingCredits >= 0 ?
            <Typography variant="body2" color="secondary">{s.wizard.noSubscription.format(remainingCredits)}</Typography> :
            <Typography variant="body2" color="error">{s.wizard.missingCredits.format(-remainingCredits, wz.availableCreditsAfterCheckout)}</Typography>}
        </div>
        <FormControl variant="outlined" style={{ width: 100 }}>
          <InputLabel >{s.paymentDialog.currency}</InputLabel>
          <Select
            onChange={(e) => handleCheckoutChange(e.target.value, 'currency')}
            label={s.paymentDialog.currency}
            value={state.checkout.currency}
          >
            <MenuItem value={"USD"}>USD</MenuItem>
            <MenuItem value={"EUR"}>EUR</MenuItem>
          </Select>
        </FormControl>
      </div>


    </div>
  );
}
